import createIcon from '../../createIcon';

/**
 * @component @name SearchOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuODQ1IDE0LjI1NDlIMTYuMDU1TDE1Ljc3NSAxMy45ODQ5QzE2Ljc1NSAxMi44NDQ5IDE3LjM0NSAxMS4zNjQ5IDE3LjM0NSA5Ljc1NDg4QzE3LjM0NSA2LjE2NDg4IDE0LjQzNSAzLjI1NDg4IDEwLjg0NSAzLjI1NDg4QzcuNDI1MDQgMy4yNTQ4OCA0LjYyNTA0IDUuODk0ODggNC4zNzUwNCA5LjI1NDg4SDYuMzk1MDRDNi42NDUwNCA3LjAwNDg4IDguNTI1MDQgNS4yNTQ4OCAxMC44NDUgNS4yNTQ4OEMxMy4zMzUgNS4yNTQ4OCAxNS4zNDUgNy4yNjQ4OCAxNS4zNDUgOS43NTQ4OEMxNS4zNDUgMTIuMjQ0OSAxMy4zMzUgMTQuMjU0OSAxMC44NDUgMTQuMjU0OUMxMC42NzUgMTQuMjU0OSAxMC41MTUgMTQuMjI0OSAxMC4zNDUgMTQuMjA0OVYxNi4yMjQ5QzEwLjUxNSAxNi4yNDQ5IDEwLjY3NSAxNi4yNTQ5IDEwLjg0NSAxNi4yNTQ5QzEyLjQ1NSAxNi4yNTQ5IDEzLjkzNSAxNS42NjQ5IDE1LjA3NSAxNC42ODQ5TDE1LjM0NSAxNC45NjQ5VjE1Ljc1NDlMMjAuMzQ1IDIwLjc0NDlMMjEuODM1IDE5LjI1NDlMMTYuODQ1IDE0LjI1NDlaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNNy44MTUwNCAxMS4wNzQ5TDUuMzQ1MDQgMTMuNTQ0OUwyLjg3NTA0IDExLjA3NDlMMi4xNjUwNCAxMS43ODQ5TDQuNjM1MDQgMTQuMjU0OUwyLjE2NTA0IDE2LjcyNDlMMi44NzUwNCAxNy40MzQ5TDUuMzQ1MDQgMTQuOTY0OUw3LjgxNTA0IDE3LjQzNDlMOC41MjUwNCAxNi43MjQ5TDYuMDU1MDQgMTQuMjU0OUw4LjUyNTA0IDExLjc4NDlMNy44MTUwNCAxMS4wNzQ5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SearchOff = createIcon('SearchOff', [
  [
    'path',
    {
      d: 'M16.845 14.2549H16.055L15.775 13.9849C16.755 12.8449 17.345 11.3649 17.345 9.75488C17.345 6.16488 14.435 3.25488 10.845 3.25488C7.42504 3.25488 4.62504 5.89488 4.37504 9.25488H6.39504C6.64504 7.00488 8.52504 5.25488 10.845 5.25488C13.335 5.25488 15.345 7.26488 15.345 9.75488C15.345 12.2449 13.335 14.2549 10.845 14.2549C10.675 14.2549 10.515 14.2249 10.345 14.2049V16.2249C10.515 16.2449 10.675 16.2549 10.845 16.2549C12.455 16.2549 13.935 15.6649 15.075 14.6849L15.345 14.9649V15.7549L20.345 20.7449L21.835 19.2549L16.845 14.2549Z',
      key: 'puxevb',
    },
  ],
  [
    'path',
    {
      d: 'M7.81504 11.0749L5.34504 13.5449L2.87504 11.0749L2.16504 11.7849L4.63504 14.2549L2.16504 16.7249L2.87504 17.4349L5.34504 14.9649L7.81504 17.4349L8.52504 16.7249L6.05504 14.2549L8.52504 11.7849L7.81504 11.0749Z',
      key: 'unw40t',
    },
  ],
]);

export default SearchOff;
